import React from "react";
import { cls } from "cls";
import { dropdownStyle } from "../../Utilities/customClassTypes";
import "../../Styles/FormDropdown.less";

interface FormDropdownProps {
  label: string;
  options: string[];
  inputName: string;
  errorMessage?: string;
  setFormValue: (key: string, value: string | number | boolean) => void;
}

const FormDropdown = ({
  options,
  inputName,
  errorMessage,
  setFormValue,
}: FormDropdownProps): JSX.Element => {
  return (
    <select
      name={inputName}
      className={`
        ${cls(
          "outline-none",
          "focus:border-blue-300",
          "focus:placeholder-transparent",
          "focus:shadow-blue",
        )}
        ${dropdownStyle(!!errorMessage)}
      `}
      defaultValue=""
      onChange={(event) => setFormValue(inputName, event.target.value)}
      data-testid={`form-dropdown-${inputName}`}
    >
      <option value="" disabled>
        Select an option
      </option>
      {options.map((option) => (
        <option value={option} key={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export default FormDropdown;
